<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";

  export let startDate = null;
  export let endDate = null;
  export let message: string;

</script>

<div class="background-white">
  <div class="grid-container">
    <div class="grid-row padding-top--smaller padding-bottom--smaller">
      <div class="grid-col c12-12">
        <UIRouterLink
          stateName="layout.reports.overview"
          params={{ startDate: startDate, endDate: endDate }}
          classes={"go-back-button margin-top--small"}
        >
          <Icon width="12" height="12" type="ArrowLeft" />
        </UIRouterLink>

        <span class="default-subheader--regular vertical-align-middle margin-bottom--small">
          {message}
        </span>
      </div>
    </div>
  </div>
</div>
